import { FC, useMemo } from "react";
import { Item, ItemProps } from ".";

interface RateProps extends ItemProps {
    value?: number;
    onChange?: (value?: number) => void;
    count?: number;
    disabled?: boolean;
    allowClear?: boolean;
}

const Rate: FC<RateProps> = ({
    value = 0,
    onChange,
    col,
    error,
    label,
    required,
    itemClassName,
    count = 5,
    disabled,
    allowClear = true
}) => {
    const wrapperClassName = useMemo(() => {
        let className = "flex items-center gap-1";

        if (disabled) {
            className += " opacity-60 cursor-not-allowed";
        }

        return className;
    }, [disabled]);

    return (
        <Item
            col={col}
            label={label}
            required={required}
            error={error}
            itemClassName={itemClassName}
        >
            <div className={wrapperClassName}>
                {Array.from({ length: count }).map((_, index) => {
                    const starValue = index + 1;
                    const active = starValue <= value;

                    return (
                        <button
                            key={starValue}
                            type="button"
                            disabled={disabled}
                            onClick={() => {
                                if (disabled) return;

                                if (allowClear && value === starValue) {
                                    onChange?.(undefined);
                                    return;
                                }

                                onChange?.(starValue);
                            }}
                            className={`
                                text-2xl transition-all duration-150
                                hover:scale-110
                                ${active ? "text-yellow-400" : "text-gray-300"}
                                ${disabled ? "" : "cursor-pointer"}
                            `}
                        >
                            <i className={active ? "fa-solid fa-star" : "fa-regular fa-star"} />
                            {/* <FontAwesomeIcon
                                icon={active ? faStarSolid : faStarRegular}
                            /> */}
                        </button>
                    );
                })}
            </div>
        </Item>
    );
};

export default Rate;